module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Bowl-34b47ea954df66ab69f780e759567c38.svg";